module.exports = __webpack_public_path__ + "img/MK.67688d52.png";